/**
 * List of known extension keys on the content link item
 */ export var ContentLinkExtensionKeys = /*#__PURE__*/ function(ContentLinkExtensionKeys) {
    /** Service understood legacy data from basic plans */ ContentLinkExtensionKeys["legacyData"] = "LegacyData";
    return ContentLinkExtensionKeys;
}({});
